<template>
  <div class="tw-p-10">
    <a
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      class="button is-primary"
    >Launch Full Values Report</a>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['props'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    href() {
      const params = [
        '/ui/advisor/reports/?reportType=impact',
        'reportStyle=minimal_relative',
        'bgcolor=%23f7f7f3',
        'dollarsOrPercentages=dollars',
      ];

      if (this.props.portfolioExtID) {
        params.push(`reporting=${this.props.portfolioExtID}`);
      }

      if (this.props.benchmarkExtID) {
        params.push(`benchmark=${this.props.benchmarkExtID}`);
      }

      if (this.props.screensetIDs?.length) {
        params.push(`values=${this.props.screensetIDs.join(',')}`);
      }

      return params.join('&');
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>

